var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-2"}),_c('div',{staticClass:"col-lg-8"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('default-template',{attrs:{"inputs":_vm.form,"checkboxs":_vm.checkboxs,"case_item":_vm.case_item}})],1)])]),_c('div',{staticClass:"col-lg-2"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }